import React, { useState } from "react";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { Column } from "react-data-grid";
import { InterventionTableQuery } from "../../../interventions/models";
import { Table, Title } from "../../../../components";
import { useGetInterventionsQuery } from "../../../interventions/queries";
import { getTablePageCount } from "../../../../helpers/tableHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { CPIntervention, CPOrderDetail } from "../../../../api/models/unified";

interface Props {
  orderDetail: CPOrderDetail;
}

const defaultTableQuery: InterventionTableQuery = {
  page: 1,
  pageSize: 10,
};

const OrderInterventionsTable: React.FC<Props> = (
  props,
): React.ReactElement => {
  const { orderDetail } = props;
  const { tOrder, tIntervention } = useCustomTranslation();

  const [queryParams, setQueryParams] = useState<InterventionTableQuery>({
    ...defaultTableQuery,
    orderId: orderDetail.id,
  });

  const query = useGetInterventionsQuery(queryParams);

  const columns: Column<CPIntervention>[] = [
    {
      key: "day",
      name: tIntervention("day"),
      renderCell: ({ row }) => renderDate(row.day),
      sortable: true,
    },
    {
      key: "categoryName",
      name: tIntervention("category"),
      sortable: true,
    },
    {
      key: "state",
      name: tIntervention("state"),
      renderCell: (props) => tIntervention(`state_${props.row.state}`),
      sortable: true,
    },
    {
      key: "primaryAssigneeName",
      name: tIntervention("primaryAssignee"),
      sortable: true,
    },
  ];

  return (
    <div className="mt-14">
      <Title className="mb-2.5 ml-5" title={tOrder("interventions")} />
      <Table
        columns={columns}
        data={query.data?.data ?? []}
        loading={query.isLoading}
        queryParams={queryParams}
        onTableQueryChange={setQueryParams}
        pageCount={getTablePageCount(
          query.data?.total ?? 1,
          queryParams.pageSize,
        )}
        detailMode
      />
    </div>
  );
};

export default OrderInterventionsTable;
